import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import ProgressButton from "react-progress-button";
import axios from "axios";
import { StateSelection, EmptyCard, CollapsiblePanel } from "@components/common";
import { AccountService, OfficerService, JurisdictionService, UserService } from "@services";
import utils from "@utils";
import {
	MASK_VALUE,
	USER_TYPE,
	USER_VETTED_STATUS,
	OFFICER_VETTED_STATUS,
	IMAGE_CHECK_LABELS,
} from "@constants";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Modal from "../Modal/Modal";
import HoldReasonModal from "../HoldReasonModal/HoldReasonModal";
import TabMenu from "../TabMenu/TabMenu";
import SelectBadges from "../SelectBadges/SelectBadges";
import Loader from "../Loader/Loader";
import ReactSelect from "../ReactSelect/ReactSelect";
import Image from "../Image/Image";
import Switch from "../Switch/Switch";
import Tooltip from "../Tooltip/Tooltip";

import "./EditAccountModal.scss";

let cancelJurisdictions;
const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
class EditAccountModal extends Component {
	constructor(props) {
		super(props);

		const { user } = props;

		this.tabMenu = [
			{
				text: "Contact Details",
				type: "contact",
				accountType: "any",
				tabNumber: 0,
			},
			{
				text: "Service Details",
				type: "service",
				accountType: "officer",
				tabNumber: 1,
			},
			{
				text: "Account",
				type: "account",
				accountType: "any",
				tabNumber: 2,
			},
			{
				text: "Diagnostics",
				type: "diagnostics",
				accountType: "officer",
				tabNumber: 3,
			},
			{
				text: "Notifications",
				type: "notifications",
				accountType: "officer",
				tabNumber: 5,
			},
			{
				text: "Verification Checklist",
				type: "checklist",
				accountType: "officer",
				tabNumber: 6,
			},
		];

		if (user.isSuperAdmin()) {
			this.tabMenu.push({
				text: "Jurisdiction History",
				type: "jurisdictions",
				accountType: "officer",
				tabNumber: 7,
			});
		}

		this.initialState = {
			infoValid: true,
			isOpen: false,
			onHold: false,
			loadingJurisdctions: false,
			loading: false,
			validProfilePhoto: true,
			validGovtPhotoFront: true,
			validGovtPhotoBack: true,
			editingVettedStatus: false,
			testNotificationButtonState: "",
			activeTab: "contact",
			tabs: [],
			officerDevices: [],
			ranks: [],
			certifications: [],
			officerCertifications: [],
			jurisdictionOptions: [],
			jurisdictionHistory: [],
			account: {},
			form: {
				contact: {
					ContactPhotoUrl: "",
					FirstName: "",
					LastName: "",
					MobilePhone: "",
					StreetAddress1: "",
					City: "",
					StateId: "",
					Zipcode: "",
					IsAdmin: false,
					IsCoordinator: false,
					IsViewOnly: false,
				},
				service: {
					HourlyRate: "",
					JurisdictionId: "",
					OfficerRankId: "",
					PONumber: "",
					SupervisorName: "",
					SupervisorEmail: "",
					SupervisorPhone: "",
					GovernmentIdBackImageUrl: "",
					GovernmentIdFrontImageUrl: "",
					OfficerNote: "",
					IsRankRestricted: "",
					CurrentJurisdictionInServiceDate: "",
				},
				account: {
					Email: "",
					Password: "",
					ConfirmPassword: "",
					VettedStatus: "",
					VettedComments: "",
					Active: false,
					ADB2CObjectID: null,
				},
				verification: {
					VettedStatus: "",
					VettedReason: "",
					VettedComments: "",
					VettedStatusExpiration: "",
					unassignSuspended: false,
				},
				instantPay: {
					shouldUpdate: false,
					Disabled: false,
					Reason: "",
				},
				isSuspensionIndefinite: true,
				currentEmail: "",
				userRole: "Staff",
			},
			accountChecklistTabsExpanded: {
				checklist: true,
				verification: true,
			},
			finishedItems: 0,
			totalItems: 0,
		};

		this.state = { ...this.initialState };

		this.approvedVettedStatus = OFFICER_VETTED_STATUS.find(item => item.value === 2);
		this.certificationsUpdated = false;
		this.originalOfficerVettedStatus = "";
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			account: { OfficerRegistrationChecklist },
		} = this.state;

		const { officerCertifications } = this.state;
		if (prevState.officerCertifications.length !== officerCertifications.length) {
			this.certificationsUpdated = true;
		}

		if ( prevState.account.OfficerRegistrationChecklist !== OfficerRegistrationChecklist && OfficerRegistrationChecklist)
			this.percentageFinishedCheck();
	}

	/**
	 * Retrieves details pertaining to an officer or user (determined by the prop `accountType`). If `accountType` is "officer",
	 * the following methods could be called as well:
	 *
	 * {@link getCertifications}, {@link getOfficerRanks}, {@link getOfficerDevices}, {@link getJurisdictionOptions}, and {@link getJurisdictionHistory},
	 * @param {Number|String} id The user ID number for the user/officer
	 */
	getAccount = id => {
		const { lang } = global;
		const { accountType, user } = this.props;

		this.setState({ loading: true });
		const serviceCall =
			accountType === "officer"
				? OfficerService.getById(id, { includeStats: true })
				: UserService.getUser(id);

		serviceCall
			.then(({ data: account }) => {
				const {
					ContactViewModel: {
						ContactPhotoUrl,
						FirstName,
						LastName,
						MobilePhone,
						StreetAddress1,
						City,
						StateId,
						Zipcode,
						IsRankRestricted,
						IsAdmin,
						IsCoordinator,
						IsViewOnly,
					},
					JurisdictionModel,
					HourlyRate,
					OfficerRankId,
					PONumber,
					SupervisorName,
					SupervisorEmail,
					SupervisorPhone,
					GovernmentIdBackImageUrl,
					GovernmentIdFrontImageUrl,
					OfficerNote,
					CurrentJurisdictionInServiceDate,
					Email,
					Active,
					VettedStatus,
					VettedComments,
					VettedReason,
					VettedStatusExpiration: rawExpiration,
					ADB2CObjectID,
				} = account;
				let VettedStatusExpiration = rawExpiration ? rawExpiration.slice(0, 10) : "";
				// Formatting for Safari and IE inputs
				if (rawExpiration && (utils.isDesktopSafari || utils.isIE)) {
					VettedStatusExpiration = utils.formatDate(
						`${rawExpiration}Z`,
						"en-US",
						user.TimeZoneId,
					);
				}
				let userRole = "Staff";
				if (IsViewOnly) userRole = "View Only";
				else if (IsAdmin) userRole = "Administrator";
				else if (IsCoordinator) userRole = "Coordinator";
				this.setState(
					prevState => ({
						...prevState,
						account,
						form: {
							...prevState.form,
							contact: {
								...prevState.form.contact,
								ContactPhotoUrl: ContactPhotoUrl || "",
								FirstName: FirstName || "",
								LastName: LastName || "",
								StreetAddress1: StreetAddress1 || "",
								City: City || "",
								StateId: StateId ?? "",
								Zipcode: Zipcode || "",
								MobilePhone: utils.formatPhoneNumber(MobilePhone),
								IsAdmin,
								IsCoordinator,
								IsViewOnly,
							},
							service: {
								...prevState.form.service,
								HourlyRate: HourlyRate ?? "",
								OfficerRankId: OfficerRankId ?? "",
								PONumber: PONumber || "",
								SupervisorName: SupervisorName || "",
								SupervisorEmail: SupervisorEmail || "",
								SupervisorPhone: SupervisorPhone || "",
								GovernmentIdBackImageUrl: GovernmentIdBackImageUrl || "",
								GovernmentIdFrontImageUrl: GovernmentIdFrontImageUrl || "",
								OfficerNote: OfficerNote || "",
								CurrentJurisdictionInServiceDate: CurrentJurisdictionInServiceDate
									? CurrentJurisdictionInServiceDate.slice(0, 10)
									: "",
								IsRankRestricted: IsRankRestricted || "",
								JurisdictionId: JurisdictionModel?.Id ?? "",
							},
							account: {
								...prevState.form.account,
								Email: Email || "",
								Active: Active || "",
								VettedStatus: VettedStatus ?? "",
								VettedComments: VettedComments || "",
								ADB2CObjectID,
							},
							verification: {
								VettedStatus: VettedStatus ?? "",
								VettedComments: VettedComments || "",
								VettedReason: VettedReason || "",
								VettedStatusExpiration: VettedStatusExpiration
									? VettedStatusExpiration.slice(0, 10)
									: "",
								unassignSuspended: false,
							},
							isSuspensionIndefinite: !VettedStatusExpiration,
							userRole,
						},
						currentEmail: Email || "",
						loading: false,
					}),
					() => {
						if (accountType === "officer") {
							this.getCertifications();
							this.getOfficerRanks();
							this.getOfficerDevices();
							if (JurisdictionModel)
								this.getJurisdictionOptions(JurisdictionModel.Name);
							if (user.isSuperAdmin()) {
								this.getJurisdictionHistory();
								this.getOfficerPaymentRestriction();
							}
							this.setInitialTab(account.VettedStatus);
						}
					},
				);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Unable to get account information"),
					timeOut: 1500,
				});
			});
	};

	/**
	 * If all fields contain valid values based on the value of prop `accountType`, this method makes an API request to update the account
	 * details for the user being edited.
	 * @param {String} holdReason The reason for placing an officer on hold. Defaults to `null`
	 * @param {Boolean} resendSupervisorEmail Whether a verification email should be re-sent to an officer's supervisor. Defaults to `false`
	 */
	setAccount = (holdReason = null, resendSupervisorEmail = false, callback = undefined) => {
		const { lang } = global;
		const { accountType } = this.props;
		const {
			account: prevData,
			form: { contact, service, account, verification, instantPay },
		} = this.state;

		if (holdReason) this.setState({ isOpen: true, onHold: false });

		// validations
		if (account.Password !== account.ConfirmPassword) {
			utils.notify({
				type: "error",
				message: lang.t("Passwords do not match"),
				timeOut: 1500,
			});

			return;
		}

		if (verification.VettedStatus === "") {
			utils.notify({
				type: "error",
				message: "Vetted status must be provided",
				timeOut: 1500,
			});

			return;
		}

		service.SupervisorPhone = utils.revertPhoneMask(service.SupervisorPhone);

		if (accountType === "officer" && service.SupervisorPhone.length !== 10) {
			utils.notify({
				type: "error",
				message: lang.t("The supervisor’s phone number must be 10 digits"),
				timeOut: 1500,
			});

			return;
		}

		contact.MobilePhone = utils.revertPhoneMask(contact.MobilePhone);

		if (contact.MobilePhone.length !== 10) {
			utils.notify({
				type: "error",
				message: lang.t("The contact’s phone number must be 10 digits"),
				timeOut: 1500,
			});

			return;
		}

		if (
			verification.VettedStatus === OFFICER_VETTED_STATUS[7].value.toString() &&
			(utils.isDesktopSafari || utils.isIE)
		) {
			const expiration = new Date(`${verification.VettedStatusExpiration} 00:00`).getTime();
			const now = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
			if (expiration < now) {
				utils.notify({
					type: "error",
					message: "Suspension must end on or after today's date",
					timeOut: 2000,
				});
				return;
			}
		}

		if (
			!holdReason &&
			verification.VettedStatus === OFFICER_VETTED_STATUS[4].value.toString()
		) {
			this.setState({ onHold: true }, () => this.close());

			this._confirmationModal.openModal({
				title: lang.t("Put Officer on Hold"),
				message: `${lang.t("Putting this officer on hold will unassign them from their upcoming jobs_")}
							${lang.t("Are you sure you want to continue_")}`,
				confirmButton: lang.t("Continue"),
				onConfirm: () => {
					this._reasonModal.openModal();
				},
				onCancel: () => {
					this.open();
				},
			});
			return;
		}

		if (contact.StateId === 0) contact.StateId = "";

		this.setState({ loading: true });
		if (accountType === "user") {
			UserService.updateUser(prevData, contact, account)
				.then(({ data: { Message: message } }) => {
					utils.notify({
						type: "success",
						message,
					});

					this.close(true);
				})
				.catch(
					({
						response: {
							data: { Message: message },
						},
					}) => {
						this.setState({ loading: false });
						utils.notify({
							type: "error",
							message,
						});
					},
				);
		} else {
			const params = {
				...prevData,
				...service,
				...account,
				...verification,
				VettedReason: holdReason || verification.VettedReason,
			};

			// if being called from the Send Request button and supervisor info is invalid, do not update officer information
			if (
				resendSupervisorEmail &&
				!/^\S+@\S+\.\S{2,}$/.test(service.SupervisorEmail) &&
				service.SupervisorName === "" &&
				service.SupervisorPhone.length !== 10
			) {
				this.setState({ loading: false, infoValid: false });
				utils.notify({
					type: "error",
					message: lang.t("Please ensure all required information is provided"),
				});
				return;
			}

			const OfficerServiceCall = OfficerService.updateOfficer(params, contact);
			let updatePaymentRestrictionCall = Promise.resolve();

			if (instantPay.shouldUpdate) {
				updatePaymentRestrictionCall = OfficerService.updateOfficerPaymentRestriction({
					UserId: prevData.Id,
					InstantPayment: instantPay.Disabled,
					Reason:
						instantPay.Reason === "" || !instantPay.Disabled ? null : instantPay.Reason,
				});
			}

			Promise.all([OfficerServiceCall, updatePaymentRestrictionCall])
				.then(
					([
						{
							data: { Message: message },
						},
					]) => {
						if (resendSupervisorEmail) {
							this.setState({ loading: false, infoValid: true });
							this.sendSupervisorEmail();
						}
						if (callback) {
							callback();
							this.setState({ loading: false });
						} else {
							utils.notify({
								type: "success",
								message,
							});
							if (this.certificationsUpdated) {
								this.updateOfficerCertifications();
							} else {
								this.close(true);
							}
						}
					},
				)
				.catch(
					({
						response: {
							data: { Message: message },
						},
					}) => {
						this.setState({ loading: false });
						utils.notify({
							type: "error",
							message,
						});
					},
				);
		}
	};

	/** Makes a request to update the list of certifications an officer has */
	updateOfficerCertifications = () => {
		const {
			account: { Id: id },
			officerCertifications,
		} = this.state;

		OfficerService.updateOfficerCertifications(
			id,
			officerCertifications.map(({ label, value }) => ({
				OfficerCertificationTypeName: label,
				OfficerCertificationTypeId: value,
			})),
		)
			.then(() => this.close(true))
			.catch(
				({
					response: {
						data: { Message: message },
					},
				}) => {
					this.setState({ loading: false });
					utils.notify({
						type: "error",
						message,
					});
				},
			);
	};

	/**
	 * Opens the modal. Called by accessing the `ref` to this component.
	 * @param {Number|String} id The user ID to use when fetching account details
	 */
	open = id => {
		const { onHold } = this.state;

		if (onHold) {
			this.setState({ isOpen: true, onHold: false });
		} else {
			this.setState(
				prevState => ({
					...prevState,
					isOpen: true,
					loading: true,
					tabs: this.getTabMenu(),
				}),
				() => this.getAccount(id),
			);
		}
	};

	/**
	 * Sets the initial tab based on the vetted status.
	 * If the vetted status is 1, the active tab is set to 'checklist'.
	 *
	 * @param {number} vettedStatus - The vetted status of the account.
	 */
	setInitialTab = vettedStatus => {
		if (vettedStatus && vettedStatus === 1) this.setActiveTab({ type: "checklist" });
	};

	/**
	 * Closes the modal
	 * @param {Boolean} wasAccountUpdated Indicates whether any account details were updated. Defaults to `false`
	 */
	close = (wasAccountUpdated = false) => {
		const { onFinished } = this.props;
		const { onHold } = this.state;
		if (onHold) {
			this.setState({ isOpen: false });
		} else {
			this.setState({ ...this.initialState }, () => {
				if (wasAccountUpdated) onFinished();
			});
		}
	};

	/** Sets which tabs are available to click based on the value of prop `accountType` */
	getTabMenu = () => {
		const { lang } = global;
		const { accountType: type } = this.props;

		return this.tabMenu
			.map(menu => ({ ...menu, text: lang.t(menu.text) }))
			.filter(({ accountType }) => accountType === "any" || accountType === type);
	};

	setActiveTab = ({ type: activeTab }) => {
		this.setState({ activeTab });
	};

	/**
	 * Handles active tab selection on mobile devices (using a `<select>` element)
	 * @param {Event} e The HTML event handled by this method
	 */
	setActiveTabOnSelect = e => {
		const { value } = e.target;
		this.setState({ activeTab: value });
	};

	/**
	 * Handles the switch control change
	 * @param {String} section The section/tab where the change is being made
	 * @param {String} fieldName The name of the property to update
	 */
	onSwitchChange = (section, fieldName) => {
		if (section) {
			this.setState(prevState => {
				let newValueSection = {
					...prevState.form[section],
					[fieldName]: !prevState.form[section][fieldName],
				};

				if (section === "instantPay") {
					newValueSection = {
						...newValueSection,
						shouldUpdate: true,
					};
				}

				return {
					...prevState,
					form: {
						...prevState.form,
						[section]: newValueSection,
					},
				};
			});
		} else {
			this.setState(prevState => ({
				...prevState,
				[fieldName]: !prevState[fieldName],
			}));
		}
	};

	/**
	 * Handles changes in most input fields shown throughout the entire modal
	 * @param {String} section The section/tab where the change is being made
	 * @param {Event} event The HTML event handled by this method
	 * @param {String} fieldName The name of the property to update
	 */
	updateField = (section, event, fieldName) => {
		let value;
		let type;
		let checked;
		if (!event) {
			value = "";
			type = "";
			checked = "";
		} else {
			({ value, type, checked } = event?.target ?? event);
		}

		switch (type) {
			case "tel":
				value = value.replace(/[^0-9.]/gi, "");
				break;
			case "checkbox":
				if (fieldName === "isSuspensionIndefinite") value = checked;
				else value = checked;
				break;
			default:
				break;
		}

		if (fieldName === "isSuspensionIndefinite") {
			this.setState(prevState => ({
				...prevState,
				form: {
					...prevState.form,
					verification: {
						...prevState.form.verification,
						VettedStatusExpiration: value
							? ""
							: prevState.form.verification.VettedStatusExpiration,
					},
					isSuspensionIndefinite: value,
				},
			}));
		} else {
			this.setState(prevState => {
				let newValueSection = {
					...prevState.form[section],
					[fieldName]: value,
				};

				if (section === "instantPay") {
					newValueSection = {
						...newValueSection,
						shouldUpdate: true,
					};
				}

				return {
					...prevState,
					form: {
						...prevState.form,
						[section]: newValueSection,
						isSuspensionIndefinite:
							fieldName === "VettedStatusExpiration"
								? value === ""
								: prevState.form.isSuspensionIndefinite,
					},
				};
			});
		}
	};

	/**
	 * Makes a request to retrieve device information if a matching token is found within the officer's list of registered devices
	 * @param {String} token A token representing an officer's device
	 */
	getDeviceInfo = token => {
		const { officerDevices } = this.state;
		const device = officerDevices.find(item => item.DeviceToken === token);

		const updateDevice = data => {
			const newOfficerDevices = officerDevices.map(item =>
				item.DeviceToken === token ? { ...item, ...data } : item,
			);
			this.setState({ officerDevices: newOfficerDevices });
		};

		if (device._expanded) {
			updateDevice({ _expanded: false });
			return;
		}

		if (device._deviceInfo && Object.keys(device._deviceInfo).length !== 0) {
			updateDevice({ _expanded: true });
		} else {
			updateDevice({ _expanded: true, _deviceInfo: {}, _loadingInfo: true });

			AccountService.getDeviceInfo(token).then(({ data }) => {
				updateDevice({ _expanded: true, _deviceInfo: data, _loadingInfo: false });
			});
		}
	};

	/** Retrieves a list of devices that belong to an officer */
	getOfficerDevices = () => {
		const { lang } = global;
		const {
			account: { Id },
		} = this.state;

		UserService.getUserDevices(Id)
			.then(({ data }) => {
				this.setState({ officerDevices: data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading officer"),
				});
			});
	};

	/** Retrieves a list of selectable officer ranks */
	getOfficerRanks = () => {
		const { lang } = global;
		OfficerService.getRanks()
			.then(({ data }) => {
				this.setState({
					ranks: data.map(rank => ({
						value: parseInt(rank.Value, 10),
						label: rank.Text,
					})),
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading officer ranks"),
				});
			});
	};

	/**
	 * Retrieves a list of jurisdictions whose names match the provided text. If `input` is empty, no jurisdictions will be searched for.
	 * @param {String} input Text used to narrow down the list of jurisdictions returned
	 */
	getJurisdictionOptions = input => {
		const { lang } = global;
		if (!input) return;

		// If there is a currentRequest going on
		// abort it to start a new one
		if (typeof cancelJurisdictions !== "undefined") {
			cancelJurisdictions();
		}

		JurisdictionService.getAll({
			scope: "Name",
			search: input,
			getCancelToken: c => {
				cancelJurisdictions = c;
			},
		})
			.then(response => {
				cancelJurisdictions = undefined;

				const options = response.data.map(option => ({
					value: option.Id,
					label: `${option.Name}, ${option.County} ${lang.t("County")} ${option.StateName}`,
				}));

				this.setState({
					jurisdictionOptions: options,
					loadingJurisdctions: false,
				});
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					utils.notify({
						type: "error",
						message: lang.t("Error loading jurisdictions"),
					});

					this.setState({
						jurisdictionOptions: [],
						loadingJurisdctions: false,
					});
				}
			});

		this.setState({
			jurisdictionOptions: [],
			loadingJurisdctions: true,
		});
	};

	/** Retrieves a selectable list of officer certifications. Upon success, {@link getOfficerCertifications} is called. */
	getCertifications = () => {
		const { lang } = global;
		OfficerService.getCertifications()
			.then(({ data }) => {
				this.setState(
					{
						certifications: data.map(
							({ OfficerCertificationTypeName, OfficerCertificationTypeId }) => ({
								label: OfficerCertificationTypeName,
								value: OfficerCertificationTypeId,
							}),
						),
					},
					this.getOfficerCertifications,
				);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error retrieving certifications"),
					title: "Error",
				});
			});
	};

	/** Retrieves the certifications obtained by an officer */
	getOfficerCertifications = () => {
		const { lang } = global;
		const {
			account: { Id },
		} = this.state;
		OfficerService.getOfficerCertifications(Id)
			.then(({ data }) => {
				this.setState({
					officerCertifications: data.map(
						({ OfficerCertificationTypeName, OfficerCertificationTypeId }) => ({
							label: OfficerCertificationTypeName,
							value: OfficerCertificationTypeId,
						}),
					),
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error retrieving officer certifications"),
					title: "Error",
				});
			});
	};

	/**
	 * Adds a certification to the list of those obtained by an officer
	 * @param {Event} event The HTML event handled by this method
	 */
	addOfficerCertification = ({ target: { value } }) => {
		const { officerCertifications, certifications } = this.state;

		const addedCertification = certifications.find(item => item.value.toString() === value);
		this.setState({ officerCertifications: [...officerCertifications, addedCertification] });
	};

	/**
	 * Removes a certification from the list of those obtained by an officer
	 * @param {String|Number} value The identifier for an officer certification
	 */
	removeOfficerCertification = value => {
		this.setState(prevState => ({
			officerCertifications: prevState.officerCertifications.filter(
				item => item.value !== value,
			),
		}));
	};

	triggerUpload = fileType => {
		this[fileType].click();
	};

	/**
	 * Verifies that the file selected to upload via file explorer is an image
	 * @param {*} file An object representing the uploaded file
	 * @param {String} name The name of the input where the uploaded file was received
	 * @returns {Boolean} `true` if `file.type` includes the text 'image'. `false` otherwise.
	 */
	verifyImageFormat = (file, name) => {
		const { type } = file;
		let property = "validProfilePhoto";
		switch (name) {
			case "GovernmentIdFrontImageUrl":
				property = "validGovtPhotoFront";
				break;
			case "GovernmentIdBackImageUrl":
				property = "validGovtPhotoBack";
				break;
			case "ContactPhotoUrl":
			default:
				break;
		}

		this.setState({ [property]: type.includes("image") });
		return type.includes("image");
	};

	/**
	 * Adds/updates an image provided by the user via API endpoint
	 * @param {Event} event The HTML event handled by this method
	 */
	uploadFile = ({ target: { files, name } }) => {
		if (!files || !files[0]) {
			return;
		}
		if (name === "verificationDocument" || this.verifyImageFormat(files[0], name)) {
			this.setState({ loading: true });

			const { lang } = global;
			const reader = new FileReader();
			reader.readAsDataURL(files[0]);

			reader.onload = _event => {
				const { account } = this.state;
				let imageType;
				let section;

				switch (name) {
					case "ContactPhotoUrl":
						section = "contact";
						imageType = 4;
						break;
					case "GovernmentIdFrontImageUrl":
						section = "service";
						imageType = 1;
						break;
					case "GovernmentIdBackImageUrl":
						section = "service";
						imageType = 2;
						break;
					default:
						break;
				}

				if (section) {
					OfficerService.uploadOfficerGovtIdImage({
						officerId: account.Id,
						fileData: files[0],
						imageType,
					})
						.then(() => {
							if (section) {
								this.setState(prevState => ({
									...prevState,
									form: {
										...prevState.form,
										[section]: {
											...prevState.form[section],
											[name]: _event.target.result,
										},
									},
									loading: false,
								}));
							} else {
								this.getAccount(account.Id);
							}
						})
						.catch(() => {
							this.setState({ loading: false });
							utils.notify({
								type: "error",
								message: lang.t("Error uploading Image"),
							});
						});
				} else {
					OfficerService.uploadOfficerVerificationDocImg({
						officerId: account.Id,
						fileData: files[0],
					})
						.then(() => {
							this.getAccount(account.Id);
						})
						.catch(() => {
							this.setState({ loading: false });
							utils.notify({
								type: "error",
								message: lang.t("Error uploading document"),
								title: "Oops",
							});
						});
				}
			};
		}
	};

	sendTestNotification = () => {
		const { lang } = global;
		const {
			account: { Id },
		} = this.state;

		const notification = {
			Title: lang.t("Test Message"),
			Body: lang.t("This is a test message from RollKall"),
		};

		this.setState({ testNotificationButtonState: "loading" });

		UserService.sendTestNotification(Id, notification)
			.then(({ data }) => {
				this.setState({ testNotificationButtonState: "success" });
				utils.notify({
					type: "success",
					message: data.Message || lang.t("The notification has been sent"),
				});
			})
			.catch(({ response }) => {
				this.setState({ testNotificationButtonState: "error" });
				utils.notify({
					type: "error",
					message: response.data.Message || lang.t("The notification could not be sent"),
				});
			});
	};

	/**
	 * Confirms the user's intention to re-verify an officer for the next 1 year
	 * @param {String} VettedComments Comments about officer verification
	 */
	verifyOfficer = VettedComments => {
		const { lang } = global;
		const { user } = this.props;
		const { account } = this.state;
		this.setState({ isOpen: false });

		const date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

		const reVerify = () => {
			this.setState({ isOpen: true });

			OfficerService.verify(account.Id, { VettedComments })
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("The officer has been re-verified"),
					});
				})
				.then(this.getAccount(account.Id))
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("The officer could not be verified"),
					});
				});
		};

		this._confirmationModal.openModal({
			title: lang.t("Verify Officer"),
			message: lang.t("dynamic.officer verification status will remain valid until date", {
				date: utils.formatDate(`${date}Z`, "en-US", user.TimeZoneId),
			}),
			confirmButton: lang.t("Re-Verify"),
			onConfirm: () => reVerify(),
			onCancel: () => this.setState({ isOpen: true }),
		});
	};

	/**
	 * Removes a verification document from an officer's verification record. _This method is only acessible by Super Admins.`
	 * @param {Number} idx Index of the array where the verification document exists
	 */
	removeOfficerVerification = idx => () => {
		const { lang } = global;
		const {
			account: { Id: officerId, UserVerificationHistory },
		} = this.state;
		const rowId = UserVerificationHistory[idx].Id;

		this.setState({ loading: true });

		OfficerService.removeOfficerVerification(officerId, rowId)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Row removed successfully"),
					title: lang.t("Success"),
				});

				this.setState(prevState => ({
					loading: false,
					account: {
						...prevState.account,
						UserVerificationHistory: prevState.account.UserVerificationHistory.map(
							item => {
								if (item.Id === rowId) return { ...item, CloudFileUrl: null };
								return item;
							},
						),
					},
				}));
			})
			.catch(() => {
				this.setState({ loading: false });
				utils.notify({
					type: "error",
					message: lang.t("Unable to delete row"),
					title: "Error",
				});
			});
	};

	/** Retrieves the jurisdiction history for an officer */
	getJurisdictionHistory = () => {
		const {
			account: { Id },
		} = this.state;
		const { lang } = global;

		OfficerService.getJurisdictionHistory(Id)
			.then(({ data }) => {
				this.setState({
					jurisdictionHistory: data,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					title: "Error",
					message: lang.t("Error loading jurisdiction history"),
				});
			});
	};

	getOfficerPaymentRestriction = () => {
		const {
			account: { Id },
		} = this.state;
		OfficerService.getOfficerPaymentRestriction(Id).then(({ data }) => {
			this.setState(prevState => ({
				...prevState,
				form: {
					...prevState.form,
					instantPay: {
						...prevState.form.instantPay,
						shouldUpdate: false,
						Disabled: data.InstantPayment,
						Reason: data.Reason || "",
					},
				},
			}));
		});
	};

	/**
	 * Formats an address object into a multi-line string
	 * @param {Object} address An object containing address details
	 * @returns {String} A formatted version of the address provided
	 * @todo Remove utility function dependency and write the string to be returned in the function body
	 */
	formatAddress = address => {
		const addressParams = {
			address: address.StreetAddress,
			city: address.City,
			state: address.StateName,
			zip: address.Zip,
			latitude: address.Latitude,
			longitude: address.Longitude,
		};

		const formattedAddress = utils.concatenateAddressDetails(
			{ ...addressParams },
			{ useMultiline: true },
		);

		return formattedAddress;
	};

	/**
	 * Builds an array from an object's property names and values
	 * @param {Object} checklist A data object with properties representing different stages of the signup process
	 * @returns {Array} An array of objects indicating the status of checklist items
	 */
	buildChecklist = checklist =>
		Object.entries(checklist).map(([label, value]) => ({
			label,
			status: value?.StatusName || global.lang.t("Unspecified"),
			value: value?.Value || global.lang.t("N/A"),
		}));

	// validate passwords match

	/** If a user's vetted status is currently being edited, the "edit mode" is cancelled and values are reset to what they were originally.
	 * Otherwise, edit mode is toggled on and the current vetted status is stored in class variable {@link originalOfficerVettedStatus}.
	 */
	toggleVettedStatusEdit = () => {
		const {
			editingVettedStatus,
			form: {
				verification: { VettedStatus },
			},
		} = this.state;
		if (editingVettedStatus) {
			this.setState(prevState => ({
				editingVettedStatus: false,
				form: {
					...prevState.form,
					verification: {
						...prevState.form.verification,
						VettedStatus: this.originalOfficerVettedStatus,
					},
				},
			}));
		} else {
			this.originalOfficerVettedStatus = VettedStatus;
			this.setState({ editingVettedStatus: true });
		}
	};

	/**
	 * Re-sends an officer's verification email to their supervisor if provided supervisor information
	 * (name, email, phone) has been minimally validated
	 */
	sendSupervisorEmail = () => {
		const { lang } = global;
		const {
			account,
			form: {
				service: { SupervisorEmail, SupervisorName, SupervisorPhone },
			},
		} = this.state;
		// validate the supervisor information before making the service call
		if (
			/^\S+@\S+\.\S{2,}$/.test(SupervisorEmail) &&
			SupervisorName !== "" &&
			SupervisorPhone.length === 10
		) {
			OfficerService.SendEmailToSupervisor(account.Id)
				.then(() => {
					this.setState({ infoValid: true });
					utils.notify({
						type: "success",
						message: lang.t("An email has been sent to the supervisor"),
					});
				})
				.catch(() => {
					this.setState({ infoValid: true });
					utils.notify({
						type: "error",
						message: lang.t("Error sending email"),
					});
				});
		} else {
			this.setState({ infoValid: false });
			utils.notify({
				type: "error",
				message: lang.t("Please ensure all required information is provided"),
			});
		}
	};

	sendOfficerVerification = () => {
		const { lang } = global;
		const {
			account: { Id },
			form: {
				account: { Email },
				service: { JurisdictionId, OfficerRankId },
			},
		} = this.state;
		if (/^\S+@\S+\.\S{2,}$/.test(Email) && JurisdictionId !== "" && OfficerRankId !== "") {
			OfficerService.sendOfficerVerification(Id)
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("An email has been sent to the officer"),
					});
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error sending email"),
					});
				});
		}
	};

	/**
	 * Updates a user's role selection
	 * @param {Event} event The HTML event handled by this method
	 */
	handleRoleChange = event => {
		const {
			target: { value },
		} = event;
		this.setState(prevState => ({
			form: {
				...prevState.form,
				contact: {
					...prevState.form.contact,
					IsAdmin: value === "Administrator" || value === "View Only",
					IsCoordinator: value === "Coordinator",
					IsViewOnly: value === "View Only",
				},
				userRole: value,
			},
		}));
	};

	hasSupervisorApproval = UserVerificationHistory =>
		!!(UserVerificationHistory && UserVerificationHistory[0]?.CloudFileUrl);

	/**
	 * Toggles the collapsing panel for a given name.
	 *
	 * @param {string} name - The name of the collapsing panel to toggle.
	 */
	toggleCollapsingPanel = name => {
		this.setState(prevState => ({
			accountChecklistTabsExpanded: {
				...prevState.accountChecklistTabsExpanded,
				[name]: !prevState.accountChecklistTabsExpanded[name],
			},
		}));
	};

	/**
	 * Calculates the percentage of finished items in the account registration checklist.
	 * Updates the state with the number of finished items and total items.
	 */
	percentageFinishedCheck = () => {
		const {
			account: {
				OfficerRegistrationChecklist,
			},
		} = this.state;

		const checkStatuses = [
			...Object.values(OfficerRegistrationChecklist.AccountProfile).map(field => ({
				finished: field.StatusName === "Finished",
			})),
			...Object.values(OfficerRegistrationChecklist.RKPay).map(field => ({
				finished: field.StatusName === "Finished",
			})),
			{
				finished:
					OfficerRegistrationChecklist.VerificationForm?.StatusName === "Finished",
			},
			{
				finished:
					OfficerRegistrationChecklist.RollKallApproval?.StatusName === "Finished",
			},
		];

		this.setState({
			finishedItems: checkStatuses.filter(x => x != null && x.finished).length,
			totalItems: checkStatuses.filter(x => x != null).length,
		});
	};

	/**
	 * Checks if all account profile fields are finished.
	 *
	 * @returns {boolean} True if all account profile fields are finished, false otherwise.
	 */
	allAccountProfileFieldsFinished = () => {
		const {
			account: { OfficerRegistrationChecklist },
		} = this.state;

		const allAccountFieldsFinished = Object.values(
			OfficerRegistrationChecklist.AccountProfile,
		).every(field => field.StatusName === "Finished");

		return allAccountFieldsFinished;
	};

	/**
	 * Handles the action of reminding an officer.
	 *
	 * @returns {Promise<void>} A promise that resolves when the reminder is sent successfully.
	 */
	handleRemindOfficer = async () => {
		const { lang } = global;
		const { account } = this.state;
		this.setState({ loading: true });

		OfficerService.getLastReminder(account.Id)
			.then(({ data }) => {
				this.setState({ loading: false });
				if (
					data.CreatedDateUTC != null &&
					new Date(data.CreatedDateUTC).getTime() >= Date.now() - 24 * 60 * 60 * 1000
				) {
					this.setState({ isOpen: false });
					this._confirmationModal.openModal({
						title: lang.t("Remind Officer"),
						message: `${lang.t("A notification has already been sent to this officer within the last 24 hours_")}
								${lang.t("Would you like to proceed with another notification_")}`,
						confirmButton: lang.t("Yes, Send Notification"),
						cancelButton: lang.t("No, Cancel"),
						onConfirm: () => this.sendReminder(),
						onCancel: () => this.setState({ isOpen: true }),
					});
				} else {
					this.sendReminder();
				}
			})
			.catch(() => {
				this.setState({ loading: false });
				utils.notify({
					type: "error",
					message: lang.t("Failed to send reminder_"),
				});
			});
	};

	/**
	 * Sends a reminder for the account.
	 */
	sendReminder = () => {
		const { account } = this.state;
		const { lang } = global;
		this.setState({ isOpen: true, loading: true });

		OfficerService.sendReminder(account.Id)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Reminder sent_"),
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Failed to send reminder_"),
				});
			})
			.finally(() => {
				this.getAccount(account.Id);
				this.setState({ loading: false });
			});
	};

	getAccountCheckValue = accountCheck => {
		if (accountCheck.label === "PhoneVerification") {
			return utils.formatPhoneNumber(accountCheck.value);
		}

		if (accountCheck.label === "SupervisorApproval") {
			return accountCheck.value ? "Approved" : "Missing Approval";
		}

		return accountCheck.value;
	};

	render() {
		const { lang } = global;
		const {
			accountType,
			user,
		} = this.props;
		const {
			infoValid,
			isOpen,
			loading,
			validProfilePhoto,
			validGovtPhotoFront,
			validGovtPhotoBack,
			editingVettedStatus,
			tabs,
			ranks,
			activeTab,
			officerDevices,
			certifications,
			officerCertifications,
			jurisdictionOptions,
			jurisdictionHistory,
			loadingJurisdctions,
			testNotificationButtonState,
			account: {
				ContactViewModel,
				OfficerDiagnosticsModel,
				UserVerificationHistory,
				OfficerRegistrationChecklist,
				OfficerJobAreaFilters,
				OfficerJobRegionFilters,
				UserTypeId,
				ADB2CObjectID,
			},
			form: { contact, service, account, verification, isSuspensionIndefinite, userRole },
			accountChecklistTabsExpanded,
			finishedItems,
			totalItems,
		} = this.state;

		const officerStatuses = OFFICER_VETTED_STATUS.filter(
			status => !["new", "expired"].includes(status.label.toLowerCase()),
		);
		const currentOfficerStatus =
			OFFICER_VETTED_STATUS.find(
				({ value }) => value === parseInt(verification.VettedStatus, 10),
			)?.label || "";
		const staffRoles = ["Staff"];
		if (UserTypeId === USER_TYPE.LAW_ENFORCEMENT) staffRoles.push("Coordinator");
		staffRoles.push("Administrator");
		staffRoles.push("View Only");

		return (
			<Fragment>
				<Modal
					id="edit-user-modal"
					size="lg"
					show={isOpen}
					onHide={() => this.close()}
				>
					<Modal.Header>
						<Modal.Title>{`${lang.t("Edit")} ${accountType === "officer" ? lang.t("Officer") : lang.t("User")}`}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<TabMenu
							tabs={tabs}
							activeTab={tabs.find(({ type }) => type === activeTab)?.tabNumber}
							onClickTab={this.setActiveTab}
							user={user}
							hiddenMobile
						/>
						<div className="visible-xs">
							<select
								name="select-tab"
								className="form-control"
								value={activeTab}
								onChange={e => this.setActiveTabOnSelect(e)}
							>
								<For
									each="item"
									of={tabs}
									index="index"
								>
									<option
										key={`item_${item.tabNumber}`}
										value={item.type}
									>
										{item.text}
									</option>
								</For>
							</select>
						</div>
						<br />
						<Choose>
							<When condition={activeTab === "contact"}>
								<form className="form-horizontal">
									<div className="row form-group">
										<label
											htmlFor="ContactPhotoUrl"
											className="control-label col-sm-4"
										>
											{lang.t("Profile Photo")}
										</label>
										<input
											id="ContactPhotoUrl"
											name="ContactPhotoUrl"
											type="file"
											accept=".jpeg,.jpg,.png,.tif,.tiff"
											className="hidden"
											ref={ref => {
												this.profilePicture = ref;
											}}
											onChange={this.uploadFile}
										/>
										<div className="col-sm-3 text-center">
											<Image
												src={contact.ContactPhotoUrl}
												className="img-thumbnail form-group"
												fallbackSrc="avatar"
											/>
											<br />
											<button
												type="button"
												onClick={() => this.triggerUpload("profilePicture")}
												className="btn btn-default"
											>
												{lang.t("Change Image")}
											</button>
										</div>
										<If condition={!validProfilePhoto}>
											<div className="col-sm-8 col-sm-offset-4 text-danger">
												{lang.t(
													"Please ensure the selected image has one of the following file extensions:",
												)}
												<br />
												{lang.t("jpeg, jpg, png, tif, tiff")}
											</div>
										</If>
									</div>
									<div className="row form-group">
										<label
											htmlFor="FirstName"
											className="col-sm-4 control-label"
										>
											{lang.t("First Name")}
										</label>
										<div className="col-sm-6">
											<input
												id="FirstName"
												name="FirstName"
												className="form-control"
												value={contact.FirstName}
												onChange={event =>
													this.updateField("contact", event, "FirstName")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="LastName"
											className="col-sm-4 control-label"
										>
											{lang.t("Last Name")}
										</label>
										<div className="col-sm-6">
											<input
												id="LastName"
												name="LastName"
												className="form-control"
												value={contact.LastName}
												onChange={event =>
													this.updateField("contact", event, "LastName")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="MobilePhone"
											className="col-sm-4 control-label"
										>
											{lang.t("Phone")}
										</label>
										<div className="col-sm-6">
											<MaskedInput
												mask={MASK_VALUE.phoneMask}
												id="MobilePhone"
												name="MobilePhone"
												className="form-control"
												value={contact.MobilePhone}
												onChange={event =>
													this.updateField(
														"contact",
														event,
														"MobilePhone",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="StreetAddress1"
											className="col-sm-4 control-label"
										>
											{lang.t("Street Address")}
										</label>
										<div className="col-sm-6">
											<input
												id="StreetAddress1"
												name="StreetAddress1"
												className="form-control"
												value={contact.StreetAddress1}
												onChange={event =>
													this.updateField(
														"contact",
														event,
														"StreetAddress1",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="City"
											className="col-sm-4 control-label"
										>
											{lang.t("City")}
										</label>
										<div className="col-sm-6">
											<input
												id="City"
												name="City"
												className="form-control"
												value={contact.City}
												onChange={event =>
													this.updateField("contact", event, "City")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="StateId"
											className="col-sm-4 control-label"
										>
											{lang.t("State")}
										</label>
										<div className="col-sm-6">
											<StateSelection
												id="StateId"
												name="StateId"
												className="form-control"
												value={contact.StateId}
												onChange={event =>
													this.updateField("contact", event, "StateId")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="Zipcode"
											className="col-sm-4 control-label"
										>
											{lang.t("Zip Code")}
										</label>
										<div className="col-sm-6">
											<input
												id="Zipcode"
												name="Zipcode"
												className="form-control"
												value={contact.Zipcode}
												onChange={event =>
													this.updateField("contact", event, "Zipcode")
												}
											/>
										</div>
									</div>
								</form>
							</When>
							<When condition={activeTab === "service"}>
								<form className="form-horizontal">
									<div className="row form-group">
										<label
											htmlFor="PONumber"
											className="col-sm-4 control-label"
										>
											{lang.t("PO Number")}
										</label>
										<div className="col-sm-6">
											<input
												id="PONumber"
												name="PONumber"
												className="form-control"
												value={service.PONumber}
												onChange={event =>
													this.updateField("service", event, "PONumber")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="JurisdictionId"
											className="col-sm-4 control-label"
										>
											{lang.t("Jurisdiction")}
										</label>
										<div className="col-sm-6">
											<ReactSelect
												name="JurisdictionId"
												value={service.JurisdictionId}
												isLoading={loadingJurisdctions}
												options={jurisdictionOptions}
												onInputChange={this.getJurisdictionOptions}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"JurisdictionId",
													)
												}
												isDisabled={!user.isSuperAdmin()}
												isClearable
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="CurrentJurisdictionInServiceDate"
											className="col-sm-4 control-label"
										>
											{lang.t("Jurisdiction In-Service Date")}
										</label>
										<div className="col-sm-6">
											<input
												id="CurrentJurisdictionInServiceDate"
												name="CurrentJurisdictionInServiceDate"
												className="form-control"
												type="date"
												value={service.CurrentJurisdictionInServiceDate}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"CurrentJurisdictionInServiceDate",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="OfficerRankId"
											className="col-sm-4 control-label"
										>
											{lang.t("Officer Rank")}
										</label>
										<div className="col-sm-6">
											<select
												id="OfficerRankId"
												name="OfficerRankId"
												className="form-control"
												value={service.OfficerRankId}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"OfficerRankId",
													)
												}
											>
												<option value=""> Select a rank... </option>
												<For
													each="rank"
													of={ranks}
												>
													<option
														key={rank.value}
														value={rank.value}
													>
														{" "}
														{rank.label}{" "}
													</option>
												</For>
											</select>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="IsRankRestricted"
											className="col-xs-4 control-label"
										>
											{lang.t("Rank Locked")}
										</label>
										<div className="col-xs-6">
											<input
												type="checkbox"
												id="IsRankRestricted"
												name="IsRankRestricted"
												className="control-label-checkbox"
												checked={service.IsRankRestricted}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"IsRankRestricted",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="certificationSelect"
											className="col-sm-4 control-label"
										>
											{lang.t("Officer Certifications")}
										</label>
										<div className="col-sm-6">
											<SelectBadges
												id="select-badges-service-form"
												defaultOption={lang.t("Select a certification")}
												optionList={certifications}
												storedOptionList={officerCertifications}
												handleOnChange={this.addOfficerCertification}
												handleOnDelete={this.removeOfficerCertification}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="HourlyRate"
											className="col-sm-4 control-label"
										>
											{lang.t("Hourly Rate")}
										</label>
										<div className="col-sm-6">
											<input
												id="HourlyRate"
												name="HourlyRate"
												className="form-control"
												type="tel"
												value={service.HourlyRate}
												onChange={event =>
													this.updateField("service", event, "HourlyRate")
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="SupervisorName"
											className="col-sm-4 control-label"
										>
											{lang.t("Supervisor Name")}
										</label>
										<div
											className={`col-sm-6 ${!infoValid && service.SupervisorName === "" ? "has-error" : ""}`}
										>
											<input
												id="SupervisorName"
												name="SupervisorName"
												className="form-control"
												value={service.SupervisorName}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"SupervisorName",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="SupervisorEmail"
											className="col-xs-12 col-sm-4 control-label"
										>
											{lang.t("Supervisor Email")}
										</label>
										<div
											className={`${
												!infoValid &&
												!/^\S+@\S+\.\S{2,}$/.test(service.SupervisorEmail)
													? "has-error"
													: ""
											} ${
												user.isSuperAdmin() &&
												service.SupervisorEmail !== "" &&
												account.VettedStatus !== 2 &&
												account.VettedStatus !== 3
													? "col-xs-7 col-sm-3 col-md-4"
													: "col-sm-6"
											}`}
										>
											<input
												id="SupervisorEmail"
												name="SupervisorEmail"
												className="form-control"
												type="email"
												value={service.SupervisorEmail}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"SupervisorEmail",
													)
												}
											/>
										</div>
										<If
											condition={
												user.isSuperAdmin() &&
												service.SupervisorEmail !== "" &&
												account.VettedStatus !== 2 &&
												account.VettedStatus !== 3
											}
										>
											<div className="col-xs-5 col-sm-3">
												<button
													type="button"
													className="btn btn-default"
													onClick={() => this.setAccount(null, true)}
												>
													{lang.t("Send Request")}
												</button>
											</div>
										</If>
									</div>
									<div className="row form-group">
										<label
											htmlFor="SupervisorPhone"
											className="col-sm-4 control-label"
										>
											{lang.t("Supervisor Phone Number")}
										</label>
										<div
											className={`col-sm-6 ${!infoValid && service.SupervisorPhone.length !== 10 ? "has-error" : ""}`}
										>
											<MaskedInput
												type="tel"
												mask={MASK_VALUE.phoneMask}
												id="SupervisorPhone"
												name="SupervisorPhone"
												className="form-control"
												value={service.SupervisorPhone}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"SupervisorPhone",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="OfficerNote"
											className="col-sm-4 control-label"
										>
											{lang.t("Notes")}
										</label>
										<div className="col-sm-6">
											<textarea
												id="OfficerNote"
												name="OfficerNote"
												className="form-control"
												value={service.OfficerNote}
												onChange={event =>
													this.updateField(
														"service",
														event,
														"OfficerNote",
													)
												}
											/>
										</div>
									</div>
									<div className="row form-group">
										<label
											htmlFor="OfficerNote"
											className="col-sm-4 control-label"
										>
											{lang.t("Government Issued Id")}
										</label>
										<div className="col-sm-4 text-center">
											<small>{lang.t("Front Image")}</small>
											<br />
											<Image
												src={service.GovernmentIdFrontImageUrl}
												className="img-thumbnail form-group"
											/>
											<br />
											<button
												type="button"
												onClick={() => this.triggerUpload("frontImage")}
												className="btn btn-default"
											>
												{lang.t("Change Image")}
											</button>
											<input
												id="GovernmentIdFrontImageUrl"
												name="GovernmentIdFrontImageUrl"
												type="file"
												accept=".jpeg,.jpg,.png,.tif,.tiff"
												className="hidden"
												ref={ref => {
													this.frontImage = ref;
												}}
												onChange={this.uploadFile}
											/>
											<If condition={!validGovtPhotoFront}>
												<div className="text-danger text-center">
													{lang.t(
														"Please ensure the selected image has one of the following file extensions:",
													)}
													<br />
													{lang.t("jpeg, jpg, png, tif, tiff")}
												</div>
											</If>
										</div>
										<div className="col-sm-4 text-center spacing-top">
											<small>{lang.t("Back Image")}</small>
											<br />
											<Image
												src={service.GovernmentIdBackImageUrl}
												className="img-thumbnail form-group"
											/>
											<br />
											<button
												type="button"
												onClick={() => this.triggerUpload("backImage")}
												className="btn btn-default"
											>
												{lang.t("Change Image")}
											</button>
											<input
												id="GovernmentIdBackImageUrl"
												name="GovernmentIdBackImageUrl"
												type="file"
												accept=".jpeg,.jpg,.png,.tif,.tiff"
												className="hidden"
												ref={ref => {
													this.backImage = ref;
												}}
												onChange={this.uploadFile}
											/>
											<If condition={!validGovtPhotoBack}>
												<div className="text-danger text-center">
													{lang.t(
														"Please ensure the selected image has one of the following file extensions:",
													)}
													<br />
													{lang.t("jpeg, jpg, png, tif, tiff")}
												</div>
											</If>
										</div>
									</div>
								</form>
							</When>
							<When condition={activeTab === "account"}>
								<form className="form-horizontal">
									<div className="row form-group">
										<label
											htmlFor="Email"
											className="col-xs-12 col-sm-4 control-label"
										>
											{lang.t("EMail")}
										</label>
										<div className="col-sm-6">
											<input
												id="Email"
												name="Email"
												className="form-control"
												type="email"
												value={account.Email}
												onChange={event =>
													this.updateField("account", event, "Email")
												}
												onKeyPress={e => {
													if (e.key === "Enter")
														this.setAccount(
															null,
															false,
															this.sendOfficerVerification,
														);
												}}
												data-test-id="login-email-input"
											/>
										</div>
									</div>
									<If condition={user.isSuperAdmin()}>
										<Choose>
											<When condition={ADB2CObjectID}>
												<div className="row form-group">
													<label
														htmlFor="ADB2CObjectID"
														className="col-sm-4 control-label"
													>
														{lang.t("Active Directory ID")}
													</label>
													<div className="col-sm-6 control-label-checkbox">
														<span>
															{account.ADB2CObjectID}
															<Tooltip
																content={lang.t(
																	"This is the object identifier in Azure Active Directory B2C. This can be useful for looking up users in the directory",
																)}
															>
																<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</span>
													</div>
												</div>
											</When>
											<Otherwise>
												<div className="row form-group">
													<label
														htmlFor="Password"
														className="col-sm-4 control-label"
													>
														{lang.t("Password")}
													</label>
													<div className="col-sm-6">
														<input
															id="Password"
															name="Password"
															type="password"
															className="form-control"
															value={account.Password}
															onChange={event =>
																this.updateField(
																	"account",
																	event,
																	"Password",
																)
															}
														/>
													</div>
												</div>
												<div className="row form-group">
													<label
														htmlFor="ConfirmPassword"
														className="col-sm-4 control-label"
													>
														{lang.t("Confirm Password")}
													</label>
													<div className="col-sm-6">
														<input
															id="ConfirmPassword"
															name="ConfirmPassword"
															type="password"
															className="form-control"
															value={account.ConfirmPassword}
															onChange={event =>
																this.updateField(
																	"account",
																	event,
																	"ConfirmPassword",
																)
															}
														/>
													</div>
												</div>
											</Otherwise>
										</Choose>
									</If>
									<div className="row form-group">
										<label
											htmlFor="Active"
											className="col-xs-4 control-label"
										>
											{lang.t("Active")}
										</label>
										<div className="col-xs-6 control-label-checkbox">
											<Switch
												on={account.Active}
												name="Active"
												onClick={() =>
													this.onSwitchChange("account", "Active")
												}
											/>
										</div>
									</div>
									<If condition={user.isSuperAdmin() && accountType === "user"}>
										<div className="row form-group">
											<label
												htmlFor="select-role"
												className="col-xs-4 control-label"
											>
												{lang.t("Role")}
											</label>
											<div className="col-xs-6">
												<select
													id="select-role"
													className="form-control"
													value={userRole}
													onChange={this.handleRoleChange}
												>
													<For
														each="item"
														of={staffRoles}
													>
														<option
															key={`staff-roles_${item}`}
															value={item}
														>
															{item}
														</option>
													</For>
												</select>
											</div>
										</div>
									</If>
									<If
										condition={
											(user.isSuperAdmin() || user.isLEA()) &&
											accountType === "user"
										}
									>
										<div className="row form-group">
											<label
												htmlFor="VettedStatus"
												className="col-sm-4 control-label"
											>
												{lang.t("Vetted Status")}
											</label>
											<div className="col-sm-6">
												<select
													id="VettedStatus"
													name="VettedStatus"
													className="form-control"
													value={account.VettedStatus}
													onChange={event =>
														this.updateField(
															"account",
															event,
															"VettedStatus",
														)
													}
												>
													<option value="">{lang.t("Select")}</option>
													<For
														each="vetted"
														of={USER_VETTED_STATUS}
													>
														<option
															key={vetted.value}
															value={vetted.value}
														>
															{" "}
															{vetted.label}{" "}
														</option>
													</For>
												</select>
											</div>
										</div>
										<div className="row form-group">
											<label
												htmlFor="VettedComments"
												className="col-sm-4 control-label"
											>
												{lang.t("Vetted Comments")}
											</label>
											<div className="col-sm-6">
												<textarea
													id="VettedComments"
													name="VettedComments"
													className="form-control"
													value={account.VettedComments}
													onChange={event =>
														this.updateField(
															"account",
															event,
															"VettedComments",
														)
													}
												/>
											</div>
										</div>
									</If>
								</form>
							</When>
							<When condition={activeTab === "diagnostics"}>
								<div className="row hidden-xs">
									<strong className="col-sm-4">{lang.t("Created Date")}</strong>
									<strong className="col-sm-4">{lang.t("Last Login")}</strong>
									<strong className="col-sm-4">
										{lang.t("Latest RK Version")}
									</strong>
								</div>
								<div className="separator separator-solid hidden-xs" />
								<div className="row">
									<div className="col-sm-4">
										<strong className="visible-xs-inline">{`${lang.t("Created Date")}: `}</strong>
										&nbsp;
										{utils.formatDate(
											new Date(`${OfficerDiagnosticsModel?.CreatedDateUTC}Z`),
											"en-US",
											user.TimeZoneId,
											user.UserPreferences === "useMilitaryTime"
												? "dt-num-mil"
												: "dt-num",
										)}
									</div>
									<div className="col-sm-4">
										<strong className="visible-xs-inline">{`${lang.t("Last Login")}: `}</strong>
										&nbsp;
										{utils.formatDate(
											new Date(
												`${OfficerDiagnosticsModel?.LastLoginDateUTC}Z`,
											),
											"en-US",
											user.TimeZoneId,
											user.UserPreferences === "useMilitaryTime"
												? "dt-num-mil"
												: "dt-num",
										)}
									</div>
									<div className="col-sm-4">
										<strong className="visible-xs-inline">{`${lang.t("Latest RK Version")}: `}</strong>
										&nbsp;
										{OfficerDiagnosticsModel?.LatestRKVersion}
									</div>
								</div>
								<If condition={user.isSuperAdmin()}>
									<br />
									<br />
									<div className="row">
										<div className="col-xs-4">
											<h4>{lang.t("Registered Devices")}</h4>
										</div>
										<div className="col-xs-8 text-right">
											<ProgressButton
												className="btn btn-primary btn-xbig"
												state={testNotificationButtonState}
												onClick={this.sendTestNotification}
											>
												{lang.t("Send Test Notification")}
											</ProgressButton>
										</div>
									</div>
									<br />
									<div className="row hidden-xs">
										<div className="col-sm-3">{lang.t("Device")}</div>
										<div className="col-sm-1">{lang.t("Platform")}</div>
										<div className="col-sm-2">{lang.t("Carrier")}</div>
										<div className="col-sm-2">{lang.t("App Version")}</div>
										<div className="col-sm-2">{lang.t("OS Version")}</div>
									</div>
									<div className="separator separator-solid hidden-xs" />
									<For
										each="device"
										index="index"
										of={officerDevices}
									>
										<div
											key={`device_${index + 1}`}
											className="row form-group v-align-sm"
										>
											<div className="col-xs-4 col-sm-3">
												<strong className="visible-xs">
													{lang.t("Device")}
												</strong>
												{device.DeviceModel}
											</div>
											<div className="col-xs-4 col-sm-1">
												<strong className="visible-xs">
													{lang.t("Platform")}
												</strong>
												{device.Platform}
											</div>
											<div className="col-xs-4 col-sm-2">
												<strong className="visible-xs">
													{lang.t("Carrier")}
												</strong>
												{device.CarrierName}
											</div>
											<div className="col-xs-4 col-sm-2">
												<strong className="visible-xs">
													{lang.t("App Version")}
												</strong>
												{device.AppVersion}
											</div>
											<div className="col-xs-4 col-sm-2">
												<strong className="visible-xs">
													{lang.t("OS Version")}
												</strong>
												{device.OSVersion}
											</div>
											<div className="col-xs-12 col-sm-2">
												<button
													type="button"
													className="btn btn-default btn-block"
													onClick={() =>
														this.getDeviceInfo(device.DeviceToken)
													}
												>
													{`${lang.t("Token Info")} ${device?._expanded ? "-" : "+"}`}
												</button>
											</div>
											<If condition={device?._expanded}>
												{device._loadingInfo && (
													<Loader
														active={device._loadingInfo}
														spinnerOnly
													/>
												)}
												<For
													each="info"
													of={Object.entries(device?._deviceInfo)}
												>
													<div
														key={`device_info_${device.DeviceToken}_${info[0]}`}
														className="col-xs-12"
													>
														{`${info[0]} : ${JSON.stringify(info[1])}`}
													</div>
												</For>
											</If>
										</div>
									</For>
								</If>
							</When>
							<When condition={activeTab === "notifications"}>
								<If condition={OfficerJobAreaFilters.length > 0}>
									<h4>{lang.t("Filtered by Radius")}</h4>
									<div className="row hidden-xs">
										<strong className="col-xs-4">
											{lang.t("Location Name")}
										</strong>
										<strong className="col-xs-4">
											{lang.t("Location Address")}
										</strong>
										<strong className="col-xs-4">{lang.t("Radius")}</strong>
									</div>
									<div className="separator separator-solid hidden-xs" />
									<For
										each="filter"
										index="index"
										of={OfficerJobAreaFilters}
									>
										<div
											key={`filter_${index}`}
											className="row"
										>
											<div className="col-sm-4">
												<strong className="visible-xs-inline">{`${lang.t("Location Name")}: `}</strong>
												&nbsp;
												{filter.LocationName}
											</div>
											<div className="col-sm-4">
												<strong className="visible-xs-inline">{`${lang.t("Location Address")}: `}</strong>
												<Choose>
													<When
														condition={
															filter.JobFilterLocationType === 4
														}
													>
														{ContactViewModel.State}
													</When>
													<Otherwise>
														{filter.LocationAddress.StreetAddress}
														<br className="hidden-xs" />
														<span className="visible-xs-inline">
															,&nbsp;
														</span>
														{filter.LocationAddress.City},{" "}
														{filter.LocationAddress.StateAbbreviation}{" "}
														{filter.LocationAddress.Zip}
													</Otherwise>
												</Choose>
											</div>
											<div className="col-sm-4">
												<strong className="visible-xs-inline">{`${lang.t("Radius")}: `}</strong>
												&nbsp;
												<Choose>
													<When
														condition={
															filter.JobFilterLocationType === 4
														}
													>
														{lang.t("Statewide")}
													</When>
													<Otherwise>
														{filter.MileRadius} {lang.t("Miles")}
													</Otherwise>
												</Choose>
											</div>
										</div>
									</For>
								</If>
								<If condition={OfficerJobAreaFilters.length === 0}>
									<EmptyCard />
								</If>
								<If condition={OfficerJobRegionFilters.length > 0}>
									<h4>{lang.t("Filtered by Locations")}</h4>
									<div className="row hidden-xs">
										<div className="col-xs-6">{lang.t("Location Name")}</div>
										<div className="col-xs-6">{lang.t("State")}</div>
									</div>
									<div className="separator separator-solid hidden-xs" />
									<For
										each="filter"
										of={OfficerJobRegionFilters}
									>
										<div className="row hidden-xs">
											<div className="col-xs-6">{filter.Name}</div>
											<div className="col-xs-4">{filter.StateName}</div>
										</div>
									</For>
								</If>
							</When>
							<When condition={activeTab === "checklist"}>
								<div className="verification-checklist">
									<div className="row">
										<CollapsiblePanel
											title={lang.t("Checklist")}
											expanded={accountChecklistTabsExpanded.checklist}
											handleToggle={() => {
												this.toggleCollapsingPanel("checklist");
											}}
										>
											<>
												<div className="row hidden-xs">
													<strong className="col-xs-4">
														{lang.t("Check")}
													</strong>
													<strong className="col-xs-4">
														{lang.t("Value")}
													</strong>
													<strong className="col-xs-4">
														{lang.t("Status")} ({finishedItems}/
														{totalItems}){" "}
													</strong>
												</div>
												<div className="separator separator-solid hidden-xs" />
												<h4>{lang.t("Account Profile")}</h4>
												<For
													each="accountCheck"
													index="index"
													of={this.buildChecklist(
														OfficerRegistrationChecklist.AccountProfile,
													)}
												>
													<div
														key={`accountCheck_${index}`}
														className="row form-group v-align-sm"
													>
														<div className="col-xs-4">
															{accountCheck.label
																.replace(/([A-Z])/g, " $1")
																.trim()}
														</div>
														<If
															condition={
																accountCheck.label ===
																IMAGE_CHECK_LABELS.PROFILE_PICTURE
															}
														>
															<div className="col-sm-4">
																<a
																	href={
																		contact.ContactPhotoUrl
																	}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	<Image
																		src={
																			contact.ContactPhotoUrl
																		}
																		className="img-thumbnail form-group checklist-profile-picture"
																	/>
																</a>
															</div>
														</If>
														<If
															condition={
																accountCheck.label ===
																IMAGE_CHECK_LABELS.GOVT_ID
															}
														>
															<div className="col-sm-2">
																<a
																	href={
																		service.GovernmentIdFrontImageUrl
																	}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	<Image
																		src={
																			service.GovernmentIdFrontImageUrl
																		}
																		className="img-thumbnail form-group"
																	/>
																</a>
															</div>
															<div className="col-sm-2">
																<a
																	href={
																		service.GovernmentIdBackImageUrl
																	}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	<Image
																		src={
																			service.GovernmentIdBackImageUrl
																		}
																		className="img-thumbnail form-group"
																	/>
																</a>
															</div>
														</If>
														<If
															condition={
																accountCheck.label !==
																	IMAGE_CHECK_LABELS.GOVT_ID &&
																accountCheck.label !==
																	IMAGE_CHECK_LABELS.PROFILE_PICTURE
															}
														>
															<div className="col-xs-4 col-wrap">
																{this.getAccountCheckValue(
																	accountCheck,
																)}
															</div>
														</If>
														<div className="col-xs-4">
															{accountCheck.status}
														</div>
													</div>
												</For>
												<br />
												<h4>{lang.t("RKPay")}</h4>
												<For
													each="rkpayCheck"
													index="index"
													of={this.buildChecklist(
														OfficerRegistrationChecklist.RKPay,
													)}
												>
													<div
														key={`accountCheck_${index}`}
														className="row form-group"
													>
														<div className="col-xs-4">
															{rkpayCheck.label}
														</div>
														<div className="col-xs-4 col-wrap">
															{rkpayCheck.value}
														</div>
														<div className="col-xs-4">
															{rkpayCheck.status}
														</div>
													</div>
												</For>
												<br />
												<h4>{`${lang.t("Verification")} / ${lang.t("Approval")}`}</h4>
												<div className="row form-group">
													<div className="col-xs-4">
														{lang.t("Verification Form")}
													</div>
													<div className="col-xs-4">
														{
															OfficerRegistrationChecklist
																.VerificationForm.Value
														}
													</div>
													<div className="col-xs-4">
														{
															OfficerRegistrationChecklist
																.VerificationForm.StatusName
														}
													</div>
												</div>
												<div className="row form-group">
													<div className="col-xs-4">
														{lang.t("Secondary Approval")}
													</div>
													<div className="col-xs-4">
														{
															OfficerRegistrationChecklist
																.RollKallApproval.Value
														}
													</div>
													<div className="col-xs-4">
														{
															OfficerRegistrationChecklist
																.RollKallApproval.StatusName
														}
													</div>
												</div>
												<If
													condition={
														!this.allAccountProfileFieldsFinished() &&
														currentOfficerStatus !==
															OFFICER_VETTED_STATUS[2].label
													}
												>
													<div className="row form-group text-center">
														<button
															type="button"
															className="btn btn-primary"
															onClick={() =>
																this.handleRemindOfficer()
															}
														>
															{lang.t("Send Notification")}
														</button>
													</div>
												</If>
											</>
										</CollapsiblePanel>
										<CollapsiblePanel
											title={lang.t("Verification")}
											expanded={accountChecklistTabsExpanded.verification}
											handleToggle={() => {
												this.toggleCollapsingPanel("verification");
											}}
										>
											<>
												<form className="form-horizontal">
													<div className="row form-group">
														<label
															htmlFor="VettedStatus"
															className="col-sm-4 control-label"
														>
															{lang.t("Vetted Status")}
														</label>
														<Choose>
															<When condition={editingVettedStatus}>
																<div className="col-xs-10 col-sm-6">
																	<select
																		id="VettedStatus"
																		name="VettedStatus"
																		className="form-control"
																		value={
																			verification.VettedStatus
																		}
																		onChange={event =>
																			this.updateField(
																				"verification",
																				event,
																				"VettedStatus",
																			)
																		}
																	>
																		<option value="">
																			{lang.t("Select")}
																		</option>
																		<For
																			each="vetted"
																			of={officerStatuses}
																		>
																			<option
																				key={vetted.value}
																				value={vetted.value}
																			>
																				{" "}
																				{vetted.label}{" "}
																			</option>
																		</For>
																	</select>
																</div>
																<div className="col-xs-2 text-left">
																	<button
																		type="button"
																		className="btn btn-link"
																		onClick={
																			this
																				.toggleVettedStatusEdit
																		}
																	>
																		<i className="glyphicon glyphicon-remove" />
																	</button>
																</div>
															</When>
															<Otherwise>
																<div className="col-sm-6">
																	<button
																		type="button"
																		className="btn btn-link"
																		onClick={
																			this
																				.toggleVettedStatusEdit
																		}
																	>
																		{currentOfficerStatus}
																	</button>
																</div>
															</Otherwise>
														</Choose>
													</div>
													<If
														condition={
															verification.VettedStatus.toString() ===
															OFFICER_VETTED_STATUS[7].value.toString()
														}
													>
														<div className="row form-group">
															<label
																htmlFor="VettedStatusExpiration"
																className="col-sm-4 control-label"
															>
																{lang.t("Suspension End Date")}
															</label>
															<div className="col-sm-3">
																<Choose>
																	<When
																		condition={
																			utils.isDesktopSafari ||
																			utils.isIE
																		}
																	>
																		<MaskedInput
																			name="VettedStatusExpiration"
																			id="VettedStatusExpiration"
																			type="text"
																			mask={dateMask}
																			className="form-control"
																			placeholder="mm/dd/yyyy"
																			value={
																				verification.VettedStatusExpiration
																			}
																			onChange={event =>
																				this.updateField(
																					"verification",
																					event,
																					"VettedStatusExpiration",
																				)
																			}
																			disabled={
																				verification.VettedStatusExpiration ===
																				null
																			}
																		/>
																	</When>
																	<Otherwise>
																		<input
																			id="VettedStatusExpiration"
																			name="VettedStatusExpiration"
																			className="form-control"
																			type="date"
																			min={utils.formatDate(
																				undefined,
																				undefined,
																				undefined,
																				"noslash",
																			)}
																			value={
																				verification.VettedStatusExpiration
																			}
																			onChange={event =>
																				this.updateField(
																					"verification",
																					event,
																					"VettedStatusExpiration",
																				)
																			}
																		/>
																	</Otherwise>
																</Choose>
															</div>
															<div className="col-sm-3">
																<input
																	type="checkbox"
																	id="isSuspensionIndefinite"
																	name="isSuspensionIndefinite"
																	checked={isSuspensionIndefinite}
																	onChange={event =>
																		this.updateField(
																			"verification",
																			event,
																			"isSuspensionIndefinite",
																		)
																	}
																/>
																<label
																	htmlFor="isSuspensionIndefinite"
																	className="control-label"
																>
																	{lang.t("Indefinite")}
																</label>
															</div>
														</div>
														<div className="row form-group">
															<label
																htmlFor="unassignSuspended"
																className="col-sm-4 control-label"
															>
																{lang.t(
																	"Unassign Officer from Jobs",
																)}
															</label>
															<div className="col-sm-6">
																<input
																	type="checkbox"
																	id="unassignSuspended"
																	name="unassignSuspended"
																	checked={
																		verification.unassignSuspended
																	}
																	onChange={event =>
																		this.updateField(
																			"verification",
																			event,
																			"unassignSuspended",
																		)
																	}
																/>
															</div>
														</div>
														<div className="row form-group">
															<label
																htmlFor="VettedReason"
																className="col-sm-4 control-label"
															>
																{lang.t("Suspension Reason")}
															</label>
															<div className="col-sm-6">
																<textarea
																	id="VettedReason"
																	name="VettedReason"
																	className="form-control"
																	value={
																		verification.VettedReason
																	}
																	onChange={event =>
																		this.updateField(
																			"verification",
																			event,
																			"VettedReason",
																		)
																	}
																/>
															</div>
														</div>
													</If>
													<div className="row form-group">
														<label
															htmlFor="VettedComments"
															className="col-sm-4 control-label"
														>
															{lang.t("Vetted Comments")}
														</label>
														<div className="col-sm-6">
															<textarea
																id="VettedComments"
																name="VettedComments"
																className="form-control"
																value={verification.VettedComments}
																onChange={event =>
																	this.updateField(
																		"verification",
																		event,
																		"VettedComments",
																	)
																}
															/>
														</div>
													</div>
													<div className="row">
														<div className="col-xs-8">
															<h4>
																{lang.t("Verification History")}
															</h4>
														</div>
														<If
															condition={
																(user.isSuperAdmin() ||
																	user.isLEA()) &&
																parseInt(
																	verification.VettedStatus,
																	10,
																) ===
																	this.approvedVettedStatus.value
															}
														>
															<div className="col-xs-4 spacing-bottom text-right">
																<button
																	type="button"
																	id="re-verify-officer"
																	className="btn btn-primary"
																	onClick={() =>
																		this.verifyOfficer(
																			verification.VettedComments,
																		)
																	}
																>
																	{lang.t("Re-Verify")}
																</button>
															</div>
														</If>
														<If condition={user.isSuperAdmin()}>
															<div className="col-xs-12 text-right spacing-bottom">
																<input
																	id="verificationDocument"
																	name="verificationDocument"
																	type="file"
																	className="hidden"
																	ref={ref => {
																		this.verificationDocument =
																			ref;
																	}}
																	onChange={this.uploadFile}
																/>
																<button
																	type="button"
																	onClick={() =>
																		this.triggerUpload(
																			"verificationDocument",
																		)
																	}
																	className="btn btn-default"
																>
																	{lang.t(
																		"Upload Verification Document",
																	)}
																</button>
															</div>
														</If>
													</div>
												</form>
												<div className="row hidden-xs">
													<strong className="col-sm-3 col-md-2">
														{lang.t("Vetted Status")}
													</strong>
													<strong className="col-sm-2">
														{lang.t("Vetted By")}
													</strong>
													<strong className="col-sm-3 col-md-4">
														{lang.t("Comments")}
													</strong>
													<strong className="col-sm-3">
														{lang.t("Attachment")}
													</strong>
												</div>
												<div className="separator separator-solid hidden-xs" />
												<For
													each="item"
													of={UserVerificationHistory || []}
													index="index"
												>
													<div
														className="row form-group"
														key={item.Id}
													>
														<div className="col-xs-6 col-sm-3 col-md-2">
															<strong className="visible-xs">
																{lang.t("Vetted Status")}
															</strong>
															<p>
																{utils.getVettedStatusText(
																	item.VettedStatus,
																)}
															</p>
														</div>
														<div className="col-xs-12 col-sm-2">
															<strong className="visible-xs">
																{lang.t("Vetted By")}
															</strong>
															<div>{item.VerifiedByUserFullName}</div>
															<div>
																{utils.formatDate(
																	new Date(
																		`${item?.VettedDateTime}Z`,
																	),
																	"en-US",
																	user.TimeZoneId,
																	"numeric",
																)}
															</div>
														</div>
														<div className="col-xs-12 col-sm-3 col-md-4">
															<If condition={item.Comments}>
																<strong className="visible-xs">
																	{lang.t("Comments")}
																</strong>
																<Choose>
																	<When
																		condition={
																			item.Reason !== null &&
																			item.Reason !== ""
																		}
																	>
																		<div>{`${item.Reason} - ${item.Comments}`}</div>
																	</When>
																	<Otherwise>
																		<div>{item.Comments}</div>
																	</Otherwise>
																</Choose>
															</If>
														</div>
														<div className="col-xs-12 col-sm-4 col-md-3">
															<If condition={item.CloudFileUrl}>
																<div className="row">
																	<div
																		className={`spacing-bottom ${user.isSuperAdmin() ? "col-sm-6" : "col-sm-12"}`}
																	>
																		<a
																			href={item.CloudFileUrl}
																			className="btn btn-primary btn-block"
																			aria-label="open verification file"
																			id="upload-verification-file"
																			target="_blank"
																			rel="noopener noreferrer"
																		>
																			{lang.t("View")}
																		</a>
																	</div>
																	<If
																		condition={user.isSuperAdmin()}
																	>
																		<div className="col-sm-6 spacing-bottom ">
																			<button
																				type="button"
																				className="btn btn-default btn-block"
																				title="remove attachment"
																				onClick={this.removeOfficerVerification(
																					index,
																				)}
																			>
																				{lang.t("Remove")}
																			</button>
																		</div>
																	</If>
																</div>
															</If>
															<div className="separator separator-solid visible-xs" />
														</div>
													</div>
												</For>
											</>
										</CollapsiblePanel>
									</div>
								</div>
							</When>
							<When condition={activeTab === "jurisdictions"}>
								<ul className="list-group">
									<For
										each="item"
										index="index"
										of={jurisdictionHistory}
									>
										<li
											key={`jurisdiction_history_${item.Jurisdiction.Id}_${index}`}
											className="list-group-item"
										>
											{`${lang.t("Name")}: ${item.Jurisdiction.Name}`}
											<br />
											{`${lang.t("Updated")}: `}
											{utils.formatDate(
												new Date(`${item.EndDateTime}Z`),
												"en-US",
												user.TimeZoneId,
												"numeric",
											)}
										</li>
									</For>
								</ul>
								<If condition={jurisdictionHistory.length === 0}>
									<EmptyCard />
								</If>
							</When>
						</Choose>
					</Modal.Body>
					<Modal.Footer>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => this.setAccount()}
						>
							{lang.t("Save")}
						</button>
						<button
							type="button"
							className="btn btn-default"
							onClick={() => this.close()}
						>
							{lang.t("Cancel")}
						</button>
					</Modal.Footer>
					<Loader active={loading} />
				</Modal>
				<ConfirmationModal
					ref={ref => {
						this._confirmationModal = ref;
					}}
				/>
				<HoldReasonModal
					ref={ref => {
						this._reasonModal = ref;
					}}
					onConfirm={reason => this.setAccount(reason)}
					onCancel={() => this.open()}
				/>
			</Fragment>
		);
	}
}

EditAccountModal.propTypes = {
	accountType: PropTypes.string.isRequired,
	user: PropTypes.object,
	onFinished: PropTypes.func,
};

EditAccountModal.defaultProps = {
	user: {},
	onFinished: () => {},
};

export default EditAccountModal;
